import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationContentBlockerDelete = {
    path: "/template/content-blocker",
    method: ERouteHttpVerb.DELETE
};
export { routeLocationContentBlockerDelete };
